import ContactUs from "components/sections/ContactUs";
import Hero from "components/sections/Hero";
import OurExpertise from "components/sections/OurExpertise";
import OurServices from "components/sections/OurServices";
import StatsBar from "components/sections/StatsBar";
import WhoWeAre from "components/sections/WhoWeAre";
import WhyChooseUs from "components/sections/WhyChooseUs";

export const Home = () => {
    return (
        <>
            <Hero />
            <StatsBar />
            <OurServices />
            <WhoWeAre />
            <WhyChooseUs />
            <OurExpertise />
            <ContactUs />
        </>
    );
};
